import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from 'moment';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

    transform(value: Duration, format?: string): number {
        if (value.isValid()) {
            switch (format) {
                case 'm':
                    return value.asMinutes();
                case 'h':
                    return value.asHours();
                case 's':
                    return value.asSeconds();
                case 'ms':
                    return value.asMilliseconds();
                default:
                    return value.asMinutes();
            }
        }
    }

}
